import _toConsumableArray from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { isArray } from 'vega-util';
import { isConditionalAxisValue } from '../axis';
import { GEOPOSITION_CHANNELS, NONPOSITION_SCALE_CHANNELS, POSITION_SCALE_CHANNELS, SCALE_CHANNELS, supportLegend, X, Y } from '../channel';
import { getFieldDef, getFieldOrDatumDef, isFieldOrDatumDef, isTypedFieldDef } from '../channeldef';
import { isGraticuleGenerator } from '../data';
import * as vlEncoding from '../encoding';
import { initEncoding } from '../encoding';
import { replaceExprRef } from '../expr';
import { GEOSHAPE, isMarkDef } from '../mark';
import { isSelectionParameter } from '../selection';
import { isFrameMixins } from '../spec/base';
import { stack } from '../stack';
import { keys } from '../util';
import { assembleAxisSignals } from './axis/assemble';
import { parseUnitAxes } from './axis/parse';
import { signalOrValueRefWithCondition, signalRefOrValue } from './common';
import { parseData as _parseData } from './data/parse';
import { assembleLayoutSignals as _assembleLayoutSignals } from './layoutsize/assemble';
import { initLayoutSize } from './layoutsize/init';
import { parseUnitLayoutSize } from './layoutsize/parse';
import { defaultFilled, initMarkdef } from './mark/init';
import { parseMarkGroups } from './mark/mark';
import { isLayerModel, ModelWithField } from './model';
import { assembleTopLevelSignals, assembleUnitSelectionData, assembleUnitSelectionMarks, assembleUnitSelectionSignals } from './selection/assemble';
import { parseUnitSelection } from './selection/parse';
/**
 * Internal model of Vega-Lite specification for the compiler.
 */

export var UnitModel = /*#__PURE__*/function (_ModelWithField) {
  _inherits(UnitModel, _ModelWithField);

  var _super = _createSuper(UnitModel);

  function UnitModel(spec, parent, parentGivenName) {
    var _this;

    var parentGivenSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var config = arguments.length > 4 ? arguments[4] : undefined;

    _classCallCheck(this, UnitModel);

    var _a;

    _this = _super.call(this, spec, 'unit', parent, parentGivenName, config, undefined, isFrameMixins(spec) ? spec.view : undefined);
    _this.specifiedScales = {};
    _this.specifiedAxes = {};
    _this.specifiedLegends = {};
    _this.specifiedProjection = {};
    _this.selection = [];
    _this.children = [];
    var markDef = isMarkDef(spec.mark) ? Object.assign({}, spec.mark) : {
      type: spec.mark
    };
    var mark = markDef.type; // Need to init filled before other mark properties because encoding depends on filled but other mark properties depend on types inside encoding

    if (markDef.filled === undefined) {
      markDef.filled = defaultFilled(markDef, config, {
        graticule: spec.data && isGraticuleGenerator(spec.data)
      });
    }

    var encoding = _this.encoding = initEncoding(spec.encoding || {}, mark, markDef.filled, config);
    _this.markDef = initMarkdef(markDef, encoding, config);
    _this.size = initLayoutSize({
      encoding: encoding,
      size: isFrameMixins(spec) ? Object.assign(Object.assign(Object.assign({}, parentGivenSize), spec.width ? {
        width: spec.width
      } : {}), spec.height ? {
        height: spec.height
      } : {}) : parentGivenSize
    }); // calculate stack properties

    _this.stack = stack(mark, encoding);
    _this.specifiedScales = _this.initScales(mark, encoding);
    _this.specifiedAxes = _this.initAxes(encoding);
    _this.specifiedLegends = _this.initLegends(encoding);
    _this.specifiedProjection = spec.projection; // Selections will be initialized upon parse.

    _this.selection = ((_a = spec.params) !== null && _a !== void 0 ? _a : []).filter(function (p) {
      return isSelectionParameter(p);
    });
    return _this;
  }

  _createClass(UnitModel, [{
    key: "hasProjection",
    get: function get() {
      var encoding = this.encoding;
      var isGeoShapeMark = this.mark === GEOSHAPE;
      var hasGeoPosition = encoding && GEOPOSITION_CHANNELS.some(function (channel) {
        return isFieldOrDatumDef(encoding[channel]);
      });
      return isGeoShapeMark || hasGeoPosition;
    }
    /**
     * Return specified Vega-Lite scale domain for a particular channel
     * @param channel
     */

  }, {
    key: "scaleDomain",
    value: function scaleDomain(channel) {
      var scale = this.specifiedScales[channel];
      return scale ? scale.domain : undefined;
    }
  }, {
    key: "axis",
    value: function axis(channel) {
      return this.specifiedAxes[channel];
    }
  }, {
    key: "legend",
    value: function legend(channel) {
      return this.specifiedLegends[channel];
    }
  }, {
    key: "initScales",
    value: function initScales(mark, encoding) {
      var _this2 = this;

      return SCALE_CHANNELS.reduce(function (scales, channel) {
        var _a;

        var fieldOrDatumDef = getFieldOrDatumDef(encoding[channel]);

        if (fieldOrDatumDef) {
          scales[channel] = _this2.initScale((_a = fieldOrDatumDef.scale) !== null && _a !== void 0 ? _a : {});
        }

        return scales;
      }, {});
    }
  }, {
    key: "initScale",
    value: function initScale(scale) {
      var domain = scale.domain,
          range = scale.range; // TODO: we could simplify this function if we had a recursive replace function

      var scaleInternal = replaceExprRef(scale);

      if (isArray(domain)) {
        scaleInternal.domain = domain.map(signalRefOrValue);
      }

      if (isArray(range)) {
        scaleInternal.range = range.map(signalRefOrValue);
      }

      return scaleInternal;
    }
  }, {
    key: "initAxes",
    value: function initAxes(encoding) {
      var _this3 = this;

      return POSITION_SCALE_CHANNELS.reduce(function (_axis, channel) {
        // Position Axis
        // TODO: handle ConditionFieldDef
        var channelDef = encoding[channel];

        if (isFieldOrDatumDef(channelDef) || channel === X && isFieldOrDatumDef(encoding.x2) || channel === Y && isFieldOrDatumDef(encoding.y2)) {
          var axisSpec = isFieldOrDatumDef(channelDef) ? channelDef.axis : undefined;
          _axis[channel] = axisSpec ? _this3.initAxis(Object.assign({}, axisSpec)) // convert truthy value to object
          : axisSpec;
        }

        return _axis;
      }, {});
    }
  }, {
    key: "initAxis",
    value: function initAxis(axis) {
      var props = keys(axis);
      var axisInternal = {};

      var _iterator = _createForOfIteratorHelper(props),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var prop = _step.value;
          var val = axis[prop];
          axisInternal[prop] = isConditionalAxisValue(val) ? signalOrValueRefWithCondition(val) : signalRefOrValue(val);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return axisInternal;
    }
  }, {
    key: "initLegends",
    value: function initLegends(encoding) {
      return NONPOSITION_SCALE_CHANNELS.reduce(function (_legend, channel) {
        var fieldOrDatumDef = getFieldOrDatumDef(encoding[channel]);

        if (fieldOrDatumDef && supportLegend(channel)) {
          var legend = fieldOrDatumDef.legend;
          _legend[channel] = legend ? replaceExprRef(legend) // convert truthy value to object
          : legend;
        }

        return _legend;
      }, {});
    }
  }, {
    key: "parseData",
    value: function parseData() {
      this.component.data = _parseData(this);
    }
  }, {
    key: "parseLayoutSize",
    value: function parseLayoutSize() {
      parseUnitLayoutSize(this);
    }
  }, {
    key: "parseSelections",
    value: function parseSelections() {
      this.component.selection = parseUnitSelection(this, this.selection);
    }
  }, {
    key: "parseMarkGroup",
    value: function parseMarkGroup() {
      this.component.mark = parseMarkGroups(this);
    }
  }, {
    key: "parseAxesAndHeaders",
    value: function parseAxesAndHeaders() {
      this.component.axes = parseUnitAxes(this);
    }
  }, {
    key: "assembleSelectionTopLevelSignals",
    value: function assembleSelectionTopLevelSignals(signals) {
      return assembleTopLevelSignals(this, signals);
    }
  }, {
    key: "assembleSignals",
    value: function assembleSignals() {
      return [].concat(_toConsumableArray(assembleAxisSignals(this)), _toConsumableArray(assembleUnitSelectionSignals(this, [])));
    }
  }, {
    key: "assembleSelectionData",
    value: function assembleSelectionData(data) {
      return assembleUnitSelectionData(this, data);
    }
  }, {
    key: "assembleLayout",
    value: function assembleLayout() {
      return null;
    }
  }, {
    key: "assembleLayoutSignals",
    value: function assembleLayoutSignals() {
      return _assembleLayoutSignals(this);
    }
  }, {
    key: "assembleMarks",
    value: function assembleMarks() {
      var _a;

      var marks = (_a = this.component.mark) !== null && _a !== void 0 ? _a : []; // If this unit is part of a layer, selections should augment
      // all in concert rather than each unit individually. This
      // ensures correct interleaving of clipping and brushed marks.

      if (!this.parent || !isLayerModel(this.parent)) {
        marks = assembleUnitSelectionMarks(this, marks);
      }

      return marks.map(this.correctDataNames);
    }
  }, {
    key: "assembleGroupStyle",
    value: function assembleGroupStyle() {
      var _ref = this.view || {},
          style = _ref.style;

      if (style !== undefined) {
        return style;
      }

      if (this.encoding.x || this.encoding.y) {
        return 'cell';
      } else {
        return undefined;
      }
    }
  }, {
    key: "getMapping",
    value: function getMapping() {
      return this.encoding;
    }
  }, {
    key: "mark",
    get: function get() {
      return this.markDef.type;
    }
  }, {
    key: "channelHasField",
    value: function channelHasField(channel) {
      return vlEncoding.channelHasField(this.encoding, channel);
    }
  }, {
    key: "fieldDef",
    value: function fieldDef(channel) {
      var channelDef = this.encoding[channel];
      return getFieldDef(channelDef);
    }
  }, {
    key: "typedFieldDef",
    value: function typedFieldDef(channel) {
      var fieldDef = this.fieldDef(channel);

      if (isTypedFieldDef(fieldDef)) {
        return fieldDef;
      }

      return null;
    }
  }]);

  return UnitModel;
}(ModelWithField);